export default (companyId: string) => ({
  _and: [
    {
      _or: [
        {
          status: {
            _neq: "SUSPENDED",
          },
        },
        {
          status: {
            _is_null: true,
          },
        },
      ],
    },
    {
      company_id: {
        _eq: companyId,
      },
      
    },
  ],
});
